import { createFileRoute } from '@tanstack/react-router'
import WorkCalculationContainer from 'Work/containers/WorkCalculationContainer'

import { Guard } from '../../-guard'

export const Route = createFileRoute('/work/$workId/calculation')({
    component: () => (
        <Guard notFeatures={['profitability']}>
            <WorkCalculationContainer />
        </Guard>
    ),
})
